import { createMarkdownElement } from './createMarkdownElement';

const MarkdownP = createMarkdownElement('p', 'md__p');
export { MarkdownP };
